module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-injekcni-metody_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/laserova-estetika/vyhlazeni-vrasek-injekcni-metody_1_before.jpg
// module id = 1018
// module chunks = 0